<template>
  <v-form class="history-filters" data-test="history-export-filters" @submit.prevent="submit">
    <v-text-field v-model="draft.from" type="date" :label="$t('license.history_export.from')" data-test="history-export-filter-from" clearable />
    <v-text-field v-model="draft.to" type="date" :label="$t('license.history_export.to')" data-test="history-export-filter-to" clearable />
    <v-text-field v-model.trim="draft.accNo" :label="$t('license.history_export.acc_no')" data-test="history-export-filter-accno" maxlength="100" clearable />
    <v-text-field v-model.trim="draft.medicalRecord" :label="$t('license.history_export.medical_record')" data-test="history-export-filter-medical-record" maxlength="100" clearable />
    <div class="history-filters__actions">
      <v-btn flat type="button" :disabled="loading" data-test="history-export-clear" @click="clear">
        {{ $t('license.history_export.clear') }}
      </v-btn>
      <v-btn color="primary" type="submit" :loading="loading" data-test="history-export-search">
        {{ $t('license.history_export.search') }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  props: { loading: { type: Boolean, default: false } },
  data: () => ({ draft: { from: '', to: '', accNo: '', medicalRecord: '' } }),
  methods: {
    submit() { this.$emit('search', { ...this.draft }) },
    clear() {
      this.draft = { from: '', to: '', accNo: '', medicalRecord: '' }
      this.$emit('search', { ...this.draft })
    },
  },
}
</script>

<style lang="scss" scoped>
.history-filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 20px;
  align-items: end;
  padding: 20px;
  border: 1px solid var(--evas-border);
  background: var(--evas-surface);
  border-radius: 4px;
}
.history-filters__actions { grid-column: 4; display: flex; justify-content: flex-end; gap: 8px; }
.history-filters__actions .v-btn { min-height: 44px; margin: 0; }
@media (max-width: 1100px) {
  .history-filters { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .history-filters__actions { grid-column: 2; }
}
@media (max-width: 600px) {
  .history-filters { grid-template-columns: 1fr; padding: 16px; }
  .history-filters__actions { grid-column: 1; }
  .history-filters__actions .v-btn { flex: 1; }
}
</style>
